import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
  PutRequestArgsType,
  DeleteRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetTeamRequiredSkillsArgsType = GetRequestArgsType & {
  teamCode: string;
};

export type PostTeamRequiredSkillPaylodType = {
  displayName: string;
  proficiencyLevel: number;
  versatility: number;
};

export type PostTeamRequiredSkillArgsType = PostRequestArgsType<PostTeamRequiredSkillPaylodType> & {
  teamCode: string;
};

export type PutTeamRequiredSkillPayloadType = {
  proficiencyLevel: number;
  versatility: number;
};

export type PutTeamRequiredSkillArgsType = PutRequestArgsType<PutTeamRequiredSkillPayloadType> & {
  teamCode: string;
  teamRequiredSkillId: number;
};

export type DeleteTeamRequiredSkillArgsType = DeleteRequestArgsType & {
  teamCode: string;
  teamRequiredSkillId: number;
};

export type GetTeamRequiredSkillsUserScoresArgsType = (
  GetRequestArgsType & {
    teamCode: string;
  }
);

export type GetTeamRequiredSkillUserScoresArgsType = (
  GetRequestArgsType & {
    teamCode: string;
    teamRequiredSkillId: number;
  }
);

export type GetTeamTenantUserRequriedSkillsScoresArgsType = (
  GetRequestArgsType & {
    teamCode: string;
    teamTenantUserId: number;
  }
);

export const apiFetchTeamRequiredSkills = async ({
  domain = useTenantStore().domain,
  teamCode,
  errorConfig = {},
  callbacks = {},
}: GetTeamRequiredSkillsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamRequiredSkills({ domain, teamCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiCreateTeamRequiredSkill = async ({
  domain = useTenantStore().domain,
  teamCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostTeamRequiredSkillArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.teamRequiredSkills({ domain, teamCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiUpdateTeamRequiredSkill = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamRequiredSkillId,
  payload,
  errorConfig = {},
  callbacks = {},
}: PutTeamRequiredSkillArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.put({
      url: urls.v1.teamRequiredSkills({
        domain,
        teamCode,
        teamRequiredSkillId,
      }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteTeamRequiredSkill = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamRequiredSkillId,
  errorConfig = {},
  callbacks = {},
}: DeleteTeamRequiredSkillArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.teamRequiredSkills({ domain, teamCode, teamRequiredSkillId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchTeamRequiredSkillsUserScores = async ({
  domain = useTenantStore().domain,
  teamCode,
  errorConfig = {},
  callbacks = {},
}: GetTeamRequiredSkillsUserScoresArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamRequiredSkillsUserScores({ domain, teamCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchTeamRequiredSkillUserScores = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamRequiredSkillId,
  errorConfig = {},
  callbacks = {},
}: GetTeamRequiredSkillUserScoresArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamRequiredSkillUserScores({
        domain,
        teamCode,
        teamRequiredSkillId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchTeamTenantUserRequiredSkillsScores = async ({
  domain = useTenantStore().domain,
  teamCode,
  teamTenantUserId,
  errorConfig = {},
  callbacks = {},
}: GetTeamTenantUserRequriedSkillsScoresArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamTenantUserRequiredSkillsScores({
        domain,
        teamCode,
        teamTenantUserId,
      }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
